export const getSpendsByStatus = (transactions: any[]) => {
    let res : any = {};
    transactions.forEach((transaction: any) => {
        let status = transaction.status || "N/A"
        if (!Object.keys(res).includes(status)) {
            res[status] = [transaction];
        } else {
            res[status].push(transaction);
        }
    });
    return res;
}

export const getSpendsByPaymentStatus = (transactions: any[]) => {
    let res : any = {};
    transactions.forEach((transaction: any) => {
        let status = transaction.paymentStatus || "N/A"
        if (!Object.keys(res).includes(status)) {
            res[status] = [transaction];
        } else {
            res[status].push(transaction);
        }
    });
    return res;
}

export const getDaysBetweenDates = (startDate: Date, endDate: Date) => {
    const oneDay = 24 * 60 * 60 * 1000;
    return Math.round(Math.abs((startDate.getTime() - endDate.getTime()) / oneDay));
}